import { render, staticRenderFns } from "./mokuai20.vue?vue&type=template&id=2255c31d&"
import script from "./mokuai20.vue?vue&type=script&lang=js&"
export * from "./mokuai20.vue?vue&type=script&lang=js&"
import style0 from "./mokuai20.vue?vue&type=style&index=0&id=2255c31d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports